/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { REACT_APP_API_URL_E_CONTRACT } from "constants/index";

import { useState } from "react";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Tab,
  Typography,
} from "@mui/material";
import { AxiosError } from "axios";
import { Button, DownloadCloud01Icon } from "components";
import { confirm } from "contexts";
import { NotFound } from "features/authorization/NotFound";
import saveAs from "file-saver";
import {
  EContractSigneeStatus,
  EContractStatus,
  useEContractControllerGetOne,
  useEContractControllerInitESign,
  useEContractControllerRequestSmsOtp,
  useEContractControllerSignContractWithEKYC,
} from "generated/ec";
import { ErrorCustom, useNotification } from "hooks/useNotification";
import { useParams } from "react-router-dom";
import { StringParam, useQueryParams } from "use-query-params";
import storage from "utils/storage";

import { EContractSignForm } from "./EContractSignForm";

export const EContractSignComponent = () => {
  const [value, setValue] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [resetIframe, setResetIframe] = useState(0);

  const [openSignModal, setOpenSignModal] = useState<boolean>(false);
  const [isValidatedPhoneNumber, setIsValidatedPhoneNumber] =
    useState<boolean>(false);
  const [openSignModalImage, setOpenSignModalImage] = useState<boolean>(false);
  const { id: idEContract } = useParams();
  const [query, setQuery] = useQueryParams({
    employeeId: StringParam,
  });
  const { employeeId } = query;

  // const { data, error, refetch } = useGetOneBaseEContractControllerEContract(
  //   idEContract as string,
  //   {
  //     join: [
  //       "createdBy",
  //       "eContractSignees",
  //       "eContractSignees.user",
  //       "type",
  //       "client",
  //       "eContractSignees.employee",
  //     ],
  //   },
  //   {
  //     axios: {
  //       baseURL: REACT_APP_API_URL_E_CONTRACT,
  //     },
  //   }
  // );

  const { data, error, refetch } = useEContractControllerGetOne(
    idEContract as string,
    {
      axios: {
        baseURL: REACT_APP_API_URL_E_CONTRACT,
      },
    }
  );

  const handleDownload = (
    eContractId: string,
    fileName: string | undefined
  ) => {
    confirm({
      title: "Download",
      content: "Are you sure you want to download?",
    })
      .then(() => {
        const fileUrl = `${REACT_APP_API_URL_E_CONTRACT}/e-contract/download-contract/${eContractId}`;
        const token = storage.getToken();
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);
        fetch(fileUrl, {
          headers,
        })
          .then((response) => {
            return response.blob();
          })
          .then((blob) => {
            saveAs(blob, fileName);
          })
          .catch(() => {});
      })
      .catch(() => {});
  };

  const {
    error: errorSmsOtp,
    mutate: requestSmsOtp,
    // eslint-disable-next-line
  } = useEContractControllerRequestSmsOtp({
    axios: {
      baseURL: REACT_APP_API_URL_E_CONTRACT,
    },
    mutation: {
      onSuccess() {
        setIsValidatedPhoneNumber(true);
      },
      onError() {
        setIsValidatedPhoneNumber(false);
      },
    },
  });

  const {
    error: errorInitESign,
    mutate: initESign,
    // eslint-disable-next-line
  } = useEContractControllerInitESign({
    axios: {
      baseURL: REACT_APP_API_URL_E_CONTRACT,
    },
  });

  const {
    error: errorSign,
    isSuccess,
    mutate: sign,
    isLoading,
  } = useEContractControllerSignContractWithEKYC({
    axios: {
      baseURL: REACT_APP_API_URL_E_CONTRACT,
    },
    mutation: {
      onSuccess() {
        refetch();
        setResetIframe(resetIframe + 1);
        setOpenSignModal(false);
        setOpenSignModalImage(false);
      },
    },
  });

  const handleSubmitRequestOtp = (input: string) => {
    // eslint-disable-next-line
    requestSmsOtp({
      data: {
        phoneNumber: input,
        employeeId: employeeId as string | undefined,
      },
    });
  };

  const handleSubmitForm = (
    smsOtp: string,
    phoneNumber: string,
    base64: string
  ) => {
    // eslint-disable-next-line
    initESign(
      { data: { smsOtp, phoneNumber } },
      {
        onSuccess(dataResponse) {
          sign({
            data: {
              eContractId: idEContract as string,
              employeeId: employeeId as string,
              imgBase64: base64?.split(",")[1],
              esignPassword: (dataResponse as any)?.data?.esignPassword,
              esignUserName: (dataResponse as any)?.data?.esignUserName,
            },
          });
        },
      }
    );
  };

  const handleSubmitSign = (input: any) => {
    sign({
      data: {
        eContractId: idEContract as string,
        imgBase64: (input?.imgBase64 as string)?.split(",")[1],
        esignCardNo: input?.idCard?.esignCardNo,
        esignFullName: input?.idCard?.esignFullName,
        esignPassword: input?.idCard?.esignPassword,
        esignUserName: input?.idCard?.esignUserName,
        employeeId: employeeId as string,
      },
    });
    setOpenSignModal(false);
    setOpenSignModalImage(false);
  };

  useNotification(error);
  useNotification(errorSmsOtp);
  useNotification(
    (errorInitESign as any)?.response?.data as
      | AxiosError<unknown, any>
      | ErrorCustom
      | null
      | undefined
  );
  useNotification(errorSign, isSuccess);
  // eslint-disable-next-line
  return data?.data ? (
    data?.data?.status === EContractStatus.Canceled ? (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <NotFound />
      </Box>
    ) : (
      <Box padding={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "40px",
            marginBottom: "28px",
          }}
        >
          <Breadcrumbs aria-label="breadcrumb">
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              color="text.primary"
            >
              Sign Contract
            </Typography>
          </Breadcrumbs>
        </Box>

        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                label={
                  data
                    ? JSON.parse(data?.data?.contractFile)?.originalName
                    : undefined
                }
                value="1"
              />
            </TabList>
          </Box>

          <TabPanel value="1">
            <Box>
              <Box paddingY={4}>
                {isLoading ? (
                  <Box height={700} position="relative">
                    <iframe
                      key={resetIframe}
                      title="contractFile"
                      width="100%"
                      height="100%"
                      src={
                        data?.data
                          ? JSON.parse(data?.data?.contractFile)?.url
                          : undefined
                      }
                    />
                    <Box
                      width="100%"
                      height="100%"
                      position="absolute"
                      top={0}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CircularProgress />
                    </Box>
                  </Box>
                ) : (
                  <iframe
                    key={resetIframe}
                    src={
                      data?.data
                        ? JSON.parse(data?.data?.contractFile)?.url
                        : undefined
                    }
                    title="contractFile"
                    width="100%"
                    height={700}
                  />
                )}
              </Box>
            </Box>
          </TabPanel>
        </TabContext>

        <Box display="flex" justifyContent="end">
          <Box>
            {data?.data?.eContractSignees?.find(
              (e) => e.employeeId === employeeId
            )?.status === EContractSigneeStatus.Signed ||
            data?.data?.eContractSignees?.find(
              (e) => e.employeeId === employeeId
            ) === undefined ? null : (
              <>
                <Button
                  sx={{ marginRight: "14px" }}
                  onClick={() => {
                    setOpenSignModal(true);
                  }}
                >
                  Ký bằng vẽ tay
                </Button>
                <Button
                  sx={{ marginRight: "14px" }}
                  onClick={() => {
                    setOpenSignModalImage(true);
                  }}
                >
                  Ký bằng hình ảnh
                </Button>
              </>
            )}

            <Button
              sx={{ marginRight: "14px" }}
              startIcon={<DownloadCloud01Icon />}
              variant="outlined"
              onClick={() => {
                handleDownload(
                  idEContract as string,
                  data?.data
                    ? (JSON.parse(data?.data?.contractFile)
                        ?.originalName as string)
                    : undefined
                );
              }}
            >
              Tải xuống
            </Button>
          </Box>
        </Box>

        <EContractSignForm
          openSignModal={openSignModal}
          setOpenSignModal={setOpenSignModal}
          refetch={refetch}
          setResetIframe={setResetIframe}
          resetIframe={resetIframe}
          isDraw
          isValidatedPhoneNumber={isValidatedPhoneNumber}
          handleSubmitSign={handleSubmitSign}
          handleSubmitRequestOtp={handleSubmitRequestOtp}
          handleSubmitForm={handleSubmitForm}
          typeName={data?.data.type.name}
        />
        <EContractSignForm
          openSignModal={openSignModalImage}
          setOpenSignModal={setOpenSignModalImage}
          refetch={refetch}
          isValidatedPhoneNumber={isValidatedPhoneNumber}
          setResetIframe={setResetIframe}
          resetIframe={resetIframe}
          handleSubmitSign={handleSubmitSign}
          handleSubmitRequestOtp={handleSubmitRequestOtp}
          handleSubmitForm={handleSubmitForm}
          typeName={data?.data.type.name}
        />
      </Box>
    )
  ) : (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};
